<template>
  <v-card>
    <pa-card-toolbar
      :title="title"
      :color="null"
      dense
    >
      <v-btn
        icon
        @click="addItem()"
      >
        <v-icon>add</v-icon>
      </v-btn>
      <v-btn
        text
        @click="save"
      >
        Save
      </v-btn>
    </pa-card-toolbar>
    <v-list :dense="dense">
      <template v-for="(item, i) in items">
        <v-divider
          v-if="i !== 0"
          :key="`div-${i}`"
        />

        <v-list-item :key="`item-${i}`">
          <slot :item="item">
            <v-list-item-content>
              <v-text-field
                v-if="editable"
                v-model="item.name"
                label="Name"
                :single-line="dense"
                hide-details
                full-width
                autofocus
                style="width:100%"
              />
              <span v-else>{{ item.name }}</span>
            </v-list-item-content>
            <v-list-item-content v-if="secondaryField">
              <v-text-field
                v-if="editable"
                v-model="item.quantity"
                :label="secondaryField"
                :single-line="dense"
                class="ml-1"
              />
              <span v-else>{{ item[secondaryField] }}</span>
            </v-list-item-content>
          </slot>
          <v-list-item-action>
            <v-btn
              icon
              @click="deleteItem(item, i)"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </template>
    </v-list>
  </v-card>
</template>

<script>
import PaCardToolbar from '@/components/shared/PaCardToolbar'

export default {
  components: {
    PaCardToolbar
  },
  props: {
    dense: {
      type: Boolean,
      default: true
    },
    editable: {
      type: Boolean,
      default: false
    },
    secondaryField: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    value: {
      type: Array,
      default: () => { return [] }
    }
  },
  data () {
    return {
      items: []
    }
  },
  watch: {
    value (val, old) {
      this.items = val.slice()
    }
  },
  mounted () {
    this.items = this.value.slice()
  },
  methods: {
    addItem () {
      this.items.push({})
    },
    deleteItem (item, i) {
      this.items.splice(i, 1)
    },
    save () {
      this.$emit('input', this.items)
    }
  }
}
</script>

<style>

</style>
